module.exports = __webpack_public_path__ + "img/phonebgc.80327be0.png";